import { Injectable } from '@angular/core';
import { getLocaleCurrencyCode, getLocaleCurrencySymbol } from '@angular/common';
import { environment } from 'environments/environment';
import { registerLocaleData } from '@angular/common';
import Britain from '@angular/common/locales/en-GB';
@Injectable({
  providedIn: 'root'
})
export class LocaleSettingService {
  // eslint-disable-next-line max-len
  private ukPostalCodeRegex: RegExp = new RegExp('^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$');
  private usPostalCodeRegex: RegExp = new RegExp('^[0-9]{5}$');
  private ukPhoneCode = 3;
  private usPhoneCode = 2;
  private locale: string;

  constructor() {
    this.locale = environment.locale || 'en-US';

    if (this.locale === 'en-GB') {
      registerLocaleData(Britain);
    }
  }

  getLocale() {
    return this.locale;
  }

  getCurrencyCode() {
    return getLocaleCurrencyCode(this.locale);
  }

  getLocaleCurrencySymbol() {
    return getLocaleCurrencySymbol(this.locale);
  }

  getLocaleZoneCategory(locale: string = this.locale) {
    switch (locale) {
      case 'en-GB':
        return 'County';
      case 'en-US':
        return 'State';
      default:
        return 'State';
    }
  }

  getLocalePostalCodeName(locale: string = this.locale) {
    switch (locale) {
      case 'en-GB':
        return 'Postcode';
      case 'en-US':
        return 'Zip Code';
      default:
        return 'Postal Code';
    }
  }

  /**
   * @param zip
   * @return string: locale
   */
  getLocaleFromPostalCode(zip: number | undefined) {
    if (zip) {
      if (this.usPostalCodeRegex.test(zip.toString())) {
        return 'en-US';
      }
      if (this.ukPostalCodeRegex.test(zip.toString())) {
        return 'en-GB';
      }
    }
    return this.locale;
  }

  getLocalePostalCodeRegex(locale: string = this.locale) {
    if (locale === 'en-GB') {
      return this.ukPostalCodeRegex;
    }
    return this.usPostalCodeRegex;
  }

  getDefaultLocalePhoneCode(locale: string = this.locale) {
    if (locale === 'en-GB') {
      return this.ukPhoneCode;
    }
    return this.usPhoneCode;
  }
}
